import {openDialog} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {EntityResourceIds, FileResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {SendCustomerEmailForm} from '../SendCustomerEmailForm/SendCustomerEmailForm';
import {DocumentItem} from './components/DocumentItem';

interface DocumentsDialogProps {
  documents: FileResponseBody[];
  text?: string;
  customerId?: string | Nullish;
  isDocxFormat?: boolean;
  permissions?: {[key: string]: boolean};
  resourceId?: EntityResourceIds;
  recordId?: string;
}

export function DocumentsDialog(props: DocumentsDialogProps) {
  const handleSendEmail = (document: FileResponseBody) =>
    openDialog(
      <SendCustomerEmailForm
        customerId={props.customerId}
        recordId={props.recordId}
        resourceId={props.resourceId}
        defaultValues={{
          attachments: [
            {
              fileName: document.pdfFilename,
              fileUrl: document.pdfUri,
              fileId: document.id,
              shouldConvertToPdf: false,
              fileType: 'application/pdf',
            },
          ],
        }}
      />,
      {
        withAdditionalFooter: true,
        size: 'large',
        title: i18n.t('general.actions.sendEmail'),
      }
    );

  return (
    <VStack spacing={6}>
      <Show when={props.text}>
        <Text size="small" color="secondary">
          {props.text}
        </Text>
        <VStack spacing={4}>
          {props.documents.map((document) => (
            <DocumentItem
              key={document.id}
              document={document}
              onSendEmail={handleSendEmail}
              data-testid="document-dialog-item"
              isDocxFormat={props.isDocxFormat}
              permissions={props.permissions}
            />
          ))}
        </VStack>
      </Show>
    </VStack>
  );
}
